import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=5435298f&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/view_member.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MemberList.vue?vue&type=style&index=1&id=5435298f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435298f",
  null
  
)

export default component.exports